import { t } from "i18next";

import { TableCellProps } from "../ProductsSelector.types";

import styles from "../ProductsSelector.module.scss";

export const SizesCell = ({ product }: TableCellProps) => {
  return (
    <div className={styles.productsTable_sizesCell}>
      {product.barcodes.map((barcode) => {
        const reservedCount = barcode.reservedItemsCount ?? 0;
        const warehouseCount = barcode.warehouseItemsCount ?? 0;
        // Sellable = what the assistant/order flow can actually sell: picking-bin
        // stock minus what's already reserved for placed/pending orders. This is
        // the headline number so the admin matches the assistant.
        const sellableCount = Math.max(
          0,
          barcode.availableItemsCount - reservedCount
        );
        const hasBreakdown = reservedCount > 0 || warehouseCount > 0;

        return (
          <div
            key={barcode.id}
            className={styles.productsTable_sizesCell_sizeItem}
          >
            <span
              className={styles.productsTable_sizesCell_sizeName}
            >{`${barcode.sizeAttributeValue.value}:`}</span>
            <span>{sellableCount}</span>
            {hasBreakdown ? (
              <span
                className={styles.productsTable_sizesCell_sizeBreakdown}
                title={`${barcode.availableItemsCount} ${t(
                  "picking"
                )} − ${reservedCount} ${t("reserved")} · ${warehouseCount} ${t(
                  "warehouse"
                )}`}
              >
                {`(${barcode.availableItemsCount} ${t(
                  "picking"
                )} − ${reservedCount} ${t("reserved")} · ${warehouseCount} ${t(
                  "warehouse"
                )})`}
              </span>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
